import { configureStore } from '@reduxjs/toolkit'
import headerSlice from '../features/common/headerSlice'
import modalSlice from '../features/common/modalSlice'
import rightDrawerSlice from '../features/common/rightDrawerSlice'
import leadsSlice from '../features/leads/leadSlice'
import companySlice  from '../features/company/companySlice'
import companysoSlice from '../features/companyso/companysoSlice'
import legalitasSlice  from '../features/legalitas/legalitasSlice'
import barangjasaSlice  from '../features/barangjasa/barangjasaSlice'
import barangjasafileSlice from '../features/barangjasa/barangjasafileSlice'
import sertifikatSlice  from '../features/sertifikat/sertifikatSlice'
import keuanganSlice  from '../features/keuangan/keuanganSlice'
import pengalamanSlice  from '../features/pengalaman/pengalamanSlice'
import documentlainSlice from '../features/documentlain/documentlainSlice'
import managementkontrakSlice  from '../features/managementkontrak/managementkontrakSlice'
import dashboardSlice  from '../features/dashboard/dashboardSlice'
import dashboardCountractSlice from '../features/dashboard/dashboardCountractSlice'
import dashboardSupplierSlice  from '../features/dashboard/dashboardSupplierSlice'
import dashboardDetailCompanySlice from '../features/dashboard/dashboardDetailCompanySlice'
import dashboardDetailCompanySoSlice from '../features/dashboard/dashboardDetailCompanySoSlice'
import dashboardDetailCompanyLegalitySlice  from '../features/dashboard/dashboardDetailCompanyLegalitySlice'
import dashboardDetailCompanyServicesSlice from '../features/dashboard/dashboardDetailCompanyServicesSlice'
import dashboardDetailCompanyCertificatSlice from '../features/dashboard/dashboardDetailCompanyCertificatSlice'
import dashboardDetailCompanyFinancialSlice from '../features/dashboard/dashboardDetailCompanyFinancialSlice'
import dashboardDetailCompanyHistorySlice from '../features/dashboard/dashboardDetailCompanyHistorySlice'
import dashboardDetailCompanyOtherSlice  from '../features/dashboard/dashboardDetailCompanyOtherSlice'
import dashboardDetailCompanyLegalityStatusSlice from '../features/dashboard/dashboardDetailCompanyLegalityStatusSlice'
import dashboardDetailCompanyServicesStatusSlice  from '../features/dashboard/dashboardDetailCompanyServicesStatusSlice'
import dashboardDetailCompanyCertificatStatusSlice from '../features/dashboard/dashboardDetailCompanyCertificateStatusSlice'
import dashboardDetailCompanyFinancialStatusSlice from '../features/dashboard/dashboardDetailCompanyFinancialStatusSlice'
import dashboardDetailCompanyHistoryStatusSlice  from '../features/dashboard/dashboardDetailCompanyHistoryStatusSlice'
import dashboardDetailCompanyOtherStatusSlice  from '../features/dashboard/dashboardDetailCompanyOtherStatusSlice'
import historyauditSlice from '../features/historyaudit/historyauditSlice'
import logdataSlice from '../features/logdata/logdataSlice';
import evaluasiSlice  from '../features/evaluasi/evaluasiSlice'
import companyImageSlice from '../features/company/companyImageSlice'
import barangjasaeditSlice from '../features/barangjasa/barangjasaeditSlice'
import daftarvendorSlice from '../features/daftarvendor/daftarvendorSlice'
import daftarbahanbakuSlice from '../features/daftarbahanbaku/daftarbahanbakuSlice'
import daftarnonbahanbakuSlice from '../features/daftarnonbahanbaku/daftarnonbahanbakuSlice'
import dashboardAuditHistorySlice from '../features/dashboard/dashboardAuditHistory'
import dashboardEvaluasiHistorySlice from '../features/dashboard/dashboardEvaluasiHistory'
import katalogSlice  from '../features/katalog/katalogSlice'
import daftarkatalogSlice from '../features/daftarkatalog/daftarkatalogSlice'
import daftarmaterialSlice from '../features/daftarmaterial/daftarmaterialSlice'
import teamSlice from '../features/settings/team/teamSlice'
import legalCheckSlice from '../features/dashboard/legalCheckSlice'
import qcCheckSlice from '../features/dashboard/qcCheckSlice'
import countSlaSlice from '../features/dashboard/countSlaSlice'
import jobAdminSlice from '../features/dashboard/jobAdminSlice'
import grandAppListSlice from '../features/dashboard/grandAppSlice'
import auditListSlice from '../features/dashboard/auditListSlice'
import tenderReducer from "../features/vendor/tender/tenderSlice";
import internalDashboardReducer from "../features/internal/dashboard/internalDashboardSlice";
import entitiesReducer from "../features/shared/entities/entitiesSlice";
import tenderFmSlice from "../features/tendermanagement/tenderFmSlice";
import internalTenderReducer from "../features/tendermanagement/internalTenderSlice";
import vendorTenderSlice from "../features/tenderoperational/vendorTenderSlice";
import evaluationReducer from "../features/tenderoperational/evaluationSlice";
import documentCheckReducer from '../features/dashboard/documentCheckSlice';

const combinedReducer = {
  header : headerSlice,
  rightDrawer : rightDrawerSlice,
  modal : modalSlice,
  lead : leadsSlice,
  company : companySlice,
  companyso: companysoSlice,
  legalitas: legalitasSlice,
  barangjasa: barangjasaSlice,
  barangjasafile: barangjasafileSlice,
  sertifikat: sertifikatSlice,
  keuangan: keuanganSlice,
  pengalaman: pengalamanSlice,
  documentlain: documentlainSlice,
  managementkontrak: managementkontrakSlice,
  dashboardproduk : dashboardSlice,
  dashboardkontrak: dashboardCountractSlice,
  dashboardsupplier: dashboardSupplierSlice,
  dashboard_detail_company : dashboardDetailCompanySlice,
  dashboard_detail_company_so : dashboardDetailCompanySoSlice,
  dashboard_detail_company_legality : dashboardDetailCompanyLegalitySlice,
  dashboard_detail_company_services : dashboardDetailCompanyServicesSlice,
  dashboard_detail_company_certificat : dashboardDetailCompanyCertificatSlice,
  dashboard_detail_company_financial : dashboardDetailCompanyFinancialSlice,
  dashboard_detail_company_history : dashboardDetailCompanyHistorySlice,
  dashboard_detail_company_other : dashboardDetailCompanyOtherSlice,
  dashboard_detail_company_legality_status : dashboardDetailCompanyLegalityStatusSlice,
  dashboard_detail_company_services_status : dashboardDetailCompanyServicesStatusSlice,
  dashboard_detail_company_certificat_status : dashboardDetailCompanyCertificatStatusSlice,
  dashboard_detail_company_financial_status : dashboardDetailCompanyFinancialStatusSlice,
  dashboard_detail_company_history_status : dashboardDetailCompanyHistoryStatusSlice,
  dashboard_detail_company_other_status : dashboardDetailCompanyOtherStatusSlice,
  historyaudit : historyauditSlice,
  historylog: logdataSlice,
  evaluasi: evaluasiSlice,
  company_image : companyImageSlice,
  barangjasa_edit: barangjasaeditSlice,
  daftar_vendor: daftarvendorSlice,
  bahan_baku: daftarbahanbakuSlice,
  nonbahan_baku: daftarnonbahanbakuSlice,
  history_audit: dashboardAuditHistorySlice,
  history_evaluasi: dashboardEvaluasiHistorySlice,
  catalog: katalogSlice,
  daftar_katalog: daftarkatalogSlice,
  daftar_material: daftarmaterialSlice,
  teams: teamSlice,
  legality_check: legalCheckSlice,
  qc_check: qcCheckSlice,
  count_sla: countSlaSlice,
  job_status: jobAdminSlice,
  grand_approval_list: grandAppListSlice,
  audit_list: auditListSlice,
  entities: entitiesReducer,
  tender: tenderReducer,
  internalDashboard: internalDashboardReducer,
  tenderFm: tenderFmSlice,
  internalTender: internalTenderReducer,
  vendorTender: vendorTenderSlice,
  evaluation: evaluationReducer,
  document_check: documentCheckReducer,
}

export default configureStore({
    reducer: combinedReducer
})